import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { CmsEncyclopediaArticle } from 'types/cms/collection-types'
import { stringify } from 'qs'

/**
 * Get the encyclopedia articles from the CMS for the given search query
 *
 * @param {string} searchQuery
 * @returns {Promise<CmsEncyclopediaArticle[]>}
 */
const getEncyclopediaArticleBySlug = async (searchQuery: string): Promise<CmsEncyclopediaArticle[]> => {
  try {
    const query = stringify({
      filters: {
        $or: [{ title: { $containsi: searchQuery } }, { description: { $containsi: searchQuery } }]
      }
    })

    const { data } = await axios.get<CMSApiResponseBody<CmsEncyclopediaArticle[]>>(
      `${process.env.CMS_API_URL}/encyclopedia-articles?${query}`
    )

    return data.data
  } catch (_) {
    return []
  }
}

export default getEncyclopediaArticleBySlug
